import React, { useState, useRef, useEffect } from 'react'

import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import {
    VideoModal,
} from '../../'
import { useEventListener } from '../../../_helpers'
import {
    ArticleTextWrap,
    UpperHeader,
    devices,
    Container,
    colors,
} from '../../Common'


export const SimpleCarousel = ({ slides, content, smallTitle, parentWidth = '', dots, captions }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [videoUrl, setVideoUrl] = useState('')
    const [height, setHeight] = useState('')
    const [carouselWidth, setCarouselWidth] = useState(parentWidth)
    const carousel = useRef()

    const handleChange = id => setActiveSlide(id)
    const openModal = video_url => {
        setShowModal(true)
        setVideoUrl(video_url)
    }
    const closeModal = () => setShowModal(false)

    const updateDimensions = () => {
        const ratio = 898 / 1469
        const width = carousel.current.offsetWidth
        setCarouselWidth(width)
        setHeight(ratio * width)
    }

    useEffect(() => {
        updateDimensions()
    }, [])

    useEventListener('resize', updateDimensions)

    return (
        <CarouselContainer ref={carousel}>
            {smallTitle ? <UpperHeader marginbottom='10'>{smallTitle}</UpperHeader> : ''}
            <StyledCarousel
                height={height}
                showStatus={false}
                showArrows={false}
                showThumbs={false}
                showIndicators={false}
                infiniteLoop={slides.length > 1}
                stopOnHover={false}
                interval={5000}
                transitionTime={1200}
                autoPlay={false}
                selectedItem={activeSlide}
                onChange={handleChange}
                carouselwidth={carouselWidth}
            >
                {slides.map(img =>
                    <div key={img.image}>
                        {img.image ? (
                            <SlideImageCard
                                height={height}
                                background={img.image}
                                orientation={img.orientation === 'portrait' ? 'contain' : 'cover'}
                                alt={img.alt_text}
                            />
                        ) : ''}
                        {img.video_url ? (
                            <VideoThumbnail image={img.video_thumbnail || img.youtube_thumbnail || img.vimeo_thumbnail} alt={img.alt_text} height={height}>
                                <VideoPlayButton onClick={() => openModal(img.video_url)} />
                            </VideoThumbnail>
                        ) : ''}
                        {img.caption && captions ? (
                            <Caption>{img.caption}</Caption>
                        ) : ''}
                    </div>
                )}
            </StyledCarousel>
            {slides && slides.length > 1 && dots ? (
                <Dots captions={captions}>
                    {slides.map((slide, i) =>
                        <Dot
                            key={i.toString()}
                            onClick={() => setActiveSlide(i)}
                            active={i === activeSlide}
                            role='button'
                            aria-label={`Hero Carousel Image ${i}`}
                        />
                    )}
                </Dots>
            ) : ''}
            {content ? <ArticleTextWrap margintop='10' dangerouslySetInnerHTML={{ __html: content }} /> : ''}
            <VideoModal
                url={videoUrl}
                showModal={showModal}
                closeModal={closeModal} />
        </CarouselContainer>
    )
}

const CarouselContainer = styled.div`
    width: ${({ carouselwidth }) => carouselwidth}px;
    margin-bottom: 30px;
    position: relative;

    @media ${devices.mobile} {
        margin-bottom: 20px;
    }
`

const StyledCarousel = styled(CarouselComp)`
    // height: ${({ height }) => height}px;
    /* max-width: 720px; */

    .slide {
        // height: ${({ height }) => height}px;
        background: transparent;
        @media ${devices.mobile} {
            height: 210px;
        }
    }

    && {
        .control-dots {
            display: none;
        }
    }
`

export const VideoThumbnail = styled.div`
    height: ${({ height }) => height}px;
    background: url(${({ image }) => image});
    background-position: center;
    background-size: cover;
    cursor: pointer;
    // margin-bottom: 30px;

    @media ${devices.mobile} {
        height: 210px;
    }
`

export const VideoPlayButton = styled.div`
    height: 55px;
    width: 47px;
    background: url(/static/images/sprite.svg) -1px -570px;
    cursor: pointer;
`

const ImageCard = styled.div`
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background: url(${props => props.background}) no-repeat 50% 50%/cover;
`

const SlideImageCard = styled(ImageCard)`
    // height: ${({ height }) => height}px;
    /* max-width: 720px; */
    margin-bottom: 0;
    background-position: top;
    @media ${devices.mobile} {
        height: 210px;
    }
`

const Dots = styled.div`
    margin-top: ${props => props.captions ? '0' : '20px'};
    width: 100%;
    text-align: ${props => props.captions ? 'right' : 'center'};
    z-index: 100;

    ${props => props.captions && `
        position: absolute;
        bottom: 0;
    `}

    @media ${devices.mobile} {
        ${Container} {
            padding-bottom: 0;
        }
    }
`

const Dot = styled.div`
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    border: 1px solid ${colors.darkGreen};
    background: ${({ active }) => active ? colors.yellow : 'transparent'};
    margin-right: 17px;
    cursor: pointer;

    &:last-child {
        margin-right: 0;
    }

    @media ${devices.mobile} {
        margin-bottom: 10px;
    }
`

const Caption = styled.div`
    text-align: left;
    margin-top: 10px;
    width: fit-content;
    font-style: italic;
`
